import { ArrowRight, Check } from "lucide-react";
import { scrollToId, useLang } from "../i18n";
import { Eyebrow, Reveal } from "./Reveal";

export default function About() {
  const { t } = useLang();
  return (
    <section id="about" className="relative overflow-hidden bg-cream py-24 lg:py-28">
      <span className="pointer-events-none absolute -left-8 top-20 hidden h-24 w-24 rounded-full border-[3px] border-gold/30 lg:block"></span>
      <span className="pointer-events-none absolute bottom-24 right-[46%] hidden h-16 w-16 rounded-full bg-gold/10 lg:block"></span>

      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-5 lg:grid-cols-2 lg:gap-20 lg:px-10">
        <Reveal>
          <button
            type="button"
            data-testid="about-experience-card"
            onClick={() => scrollToId("book")}
            aria-label={t.about.imgCta}
            className="group relative block w-full overflow-hidden rounded-[28px] text-left shadow-2xl"
          >
            <img
              src="/assets/taxi-hero.png"
              alt="Singh Taxi — professional taxi service"
              className="h-[420px] w-full object-cover transition-transform duration-700 group-hover:scale-105 sm:h-[540px]"
              style={{ objectPosition: "center 55%" }}
            />
            <span
              data-testid="about-image-cta"
              className="absolute right-4 top-4 inline-flex items-center gap-2 rounded-full bg-gold px-5 py-2.5 text-[13px] font-extrabold text-black shadow-lg transition-transform group-hover:-translate-y-0.5"
            >
              {t.about.imgCta}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </span>
            <div className="absolute inset-x-4 bottom-4 flex items-center gap-4 rounded-2xl bg-black/50 px-5 py-4 backdrop-blur-md">
              <span className="font-serif text-3xl text-gold">
                {t.about.stripValue}
              </span>
              <span className="text-[11px] font-bold leading-relaxed tracking-[0.25em] text-white">
                {t.about.stripLabel}
              </span>
            </div>
          </button>
        </Reveal>

        <div>
          <Reveal>
            <Eyebrow>{t.about.eyebrow}</Eyebrow>
            <h2
              data-testid="about-heading"
              className="mt-5 font-serif text-4xl text-[#141414] sm:text-5xl"
            >
              {t.about.title}
            </h2>
          </Reveal>
          <Reveal delay={0.08}>
            <div className="mt-7 space-y-5 text-[15px] leading-relaxed text-gray-600">
              <p>{t.about.p1}</p>
              <p>{t.about.p2}</p>
              <p>{t.about.p3}</p>
            </div>
          </Reveal>
          <Reveal delay={0.14}>
            <div className="mt-8 grid gap-3 sm:grid-cols-2">
              {t.about.checks.map((c) => (
                <div
                  key={c}
                  className="flex items-center gap-3 rounded-xl border border-black/5 bg-white px-4 py-3.5 shadow-sm"
                >
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold">
                    <Check className="h-3.5 w-3.5 text-black" strokeWidth={3.5} />
                  </span>
                  <span className="text-[13px] font-semibold text-[#222]">
                    {c}
                  </span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
